import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import ShopSyncedMaterialListPage from '@/temu-platform/modules/templates/ShopSyncedMaterialListPage';
import { useTemuShopOptional } from '@/temu-platform/context/TemuShopContext';
import {
  buildTemuPath,
  parseTemuShopTypeSlugFromPath,
} from '@/temu-platform/constants/temuRoutes';
import { temuShopCapabilities } from '@/temu-platform/utils/temuShopCapabilities';
import { showToast } from '@/utils/toast';

function useSkipSiteWarehouseFreightTemplateLib() {
  const activeShop = useTemuShopOptional()?.activeShop ?? null;
  return useMemo(() => {
    const fromShop = Boolean(temuShopCapabilities(activeShop?.shopType).skipSiteWarehouseFreight);
    if (fromShop) return true;
    const slug = parseTemuShopTypeSlugFromPath(
      typeof window !== 'undefined' ? window.location.pathname : '',
    );
    return slug === 'full' || slug === 'local';
  }, [activeShop?.shopType]);
}

/** 模板库 · 运费模板（店铺同步，无官方库；全托管/本土不提供） */
export default function FreightTemplatePage() {
  const { t } = useTranslation('workbench');
  const navigate = useNavigate();
  const skip = useSkipSiteWarehouseFreightTemplateLib();

  useEffect(() => {
    if (!skip) return;
    showToast(t('freightLib.skipShop'), 'info');
    navigate(buildTemuPath('templates/product'), { replace: true });
  }, [skip, navigate, t]);

  if (skip) return null;

  return (
    <ShopSyncedMaterialListPage
      kind="freight"
      libraryLabel={t('freightLib.library')}
      idColumnLabel={t('freightLib.colId')}
      nameColumnLabel={t('freightLib.colName')}
      syncHint={t('freightLib.syncHintTemu')}
      showPlatformJson
    />
  );
}
